<template>
  <div ref="summaryRegion" v-show="show" class="summary-region">
    <div v-show="city" class="summary-region__place">
      <div class="summary-region__names">
        <div class="summary-region__city">{{ city }}</div>
        <div v-show="showProvince" class="summary-region__province">{{ province }}</div>
      </div>
      <div v-if="data" class="summary-region__subtitle">
        <!-- <img class="summary-region__trophy" src="@/assets/img/beker.svg" /> -->
        <div class="summary-region__position">{{ year }}</div>
        <img class="summary-region__residents" src="@/assets/img/inwoneraantal.svg" />
        <div class="summary-region__count">{{ data.inwoners | thousandsSeparator }}</div>
      </div>
    </div>

    <div v-if="data" class="summary-region__numbers">
      <!-- <template v-if="!isMobile">
        <div class="summary-region__row">
          <div class="summary-region__label">Solvabiliteit</div>
          <div class="summary-region__label">Netto/gecorrigeerde<br>schuldquote</div>
          <div class="summary-region__label">Grondexploitatie</div>
          <div class="summary-region__label">Structurele<br>exploitatieruimte</div>
          <div class="summary-region__label">Belastingcapaciteit</div>
        </div>
        <div class="summary-region__row --text">
          <div class="summary-region__item">{{ data.solvabiliteit | decimalSeparator }}</div>
          <div class="summary-region__item">{{ data.schuldquote | decimalSeparator }}</div>
          <div class="summary-region__item">{{ data.grond | decimalSeparator }}</div>
          <div class="summary-region__item">{{ data.exploitatie | decimalSeparator }}</div>
          <div class="summary-region__item">{{ data.belasting | decimalSeparator }}</div>
        </div>
      </template> -->

      <template>
        <div class="summary-region__row">
          <div class="summary-region__label">Solvabiliteit</div>
          <div class="summary-region__label">Netto/gecorrigeerde<br>schuldquote</div>
        </div>
        <div class="summary-region__row --text">
          <div class="summary-region__item">{{ data.solvabiliteit | decimalSeparator }}</div>
          <div class="summary-region__item">{{ data.schuldquote | decimalSeparator }}</div>
        </div>

        <div class="summary-region__row">
          <div class="summary-region__label">Grondexploitatie</div>
          <div class="summary-region__label">Structurele<br>exploitatieruimte</div>
        </div>
        <div class="summary-region__row --text">
          <div class="summary-region__item">{{ data.grond | decimalSeparator }}</div>
          <div class="summary-region__item">{{ data.exploitatie | decimalSeparator }}</div>
        </div>

        <div class="summary-region__row">
          <div class="summary-region__label">Belastingcapaciteit</div>
          <div v-if="data.trendrating" class="summary-region__label">Trendrating</div>
        </div>
        <div class="summary-region__row --text">
          <div class="summary-region__item">{{ data.belasting | decimalSeparator }}</div>
          <div v-if="data.trendrating" class="summary-region__item">
            <img :src="trendImageMapping[data.trendrating]" />
          </div>
        </div>
      </template>
    </div>

    <summary-graph :region="selectedRegion" :size="type" />

    <!-- <div class="summary-region__disclaimer">
      * gecorrigeerd voor alle verstrekte leningen
    </div> -->
  </div>
</template>

<script>
import getEventPath from '@/helpers/mouse-event';
import { mapState, mapGetters } from 'vuex';
import isMobile from '@/helpers/platform';

export default {
  name: 'SummaryRegion',

  props: {
    /**
     * Hide container on click outside
     */
    clickOutside: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      states: {
        '0,25000': 'small',
        '25000,50000': 'medium',
        '50000,100000': 'normal',
        '100000,20000000': 'large',
      },
      trendImageMapping: {
        DOWN: 'img/assets/trend-down.svg',
        SAME: 'img/assets/trend-same.svg',
        UP: 'img/assets/trend-up.svg',
      },

      show: false,
      previousShowState: true,
      showProvince: false,
    };
  },

  computed: {
    ...mapState({
      selectedRegion: (state) => state.dataLayer.selected,
      feature: (state) => state.dataLayer.feature,
      provincesMap: (state) => state.provinces.map,
      year: (state) => state.rawData.year,
    }),

    ...mapGetters({
      rawData: 'rawData/all',
      statedFilters: 'filter/filters',
    }),

    isMobile() {
      return isMobile();
    },

    city() {
      return this.selectedRegion;
    },

    province() {
      return this.provincesMap[this.selectedRegion];
    },

    type() {
      return this.states[this.statedFilters?.Inwoners?.value[0]];
    },

    data() {
      if (this.rawData) {
        const rawData = this.rawData[this.year];

        if (rawData) {
          const obj = rawData.filter((item) => item.Gemeente === this.city);

          return {
            inwoners: obj[0]?.Inwoners,
            solvabiliteit: obj[0]?.Solvabiliteit,
            schuldquote: obj[0]?.Schuldquote,
            grond: obj[0]?.Grondexploitatie,
            exploitatie: obj[0]?.Exploitatieruimte,
            belasting: obj[0]?.Belastingcapaciteit,
            score: obj[0]?.Ranking,
            trendrating: obj[0]?.Trendrating,
            length: rawData.length,
          };
        }
      }

      return null;
    },
  },

  watch: {
    show(value) {
      if (value) {
        this.$emit('shown');

        return;
      }

      this.$emit('hide');
    },

    selectedRegion(value) {
      if (value === null) {
        this.show = false;
        this.previousShowState = true;

        return;
      }

      if (this.show) {
        this.previousShowState = true;
      }
      this.show = true;
    },
  },

  mounted() {
    if (this.clickOutside) {
      document.body.addEventListener('click', this.onClickOutside);
    }
  },

  methods: {
    onClickOutside(event) {
      const component = this.$refs.summaryRegion;
      const path = getEventPath(event);
      if (component === event.target || (path != null && path.indexOf(component) > -1)) {
        return;
      }

      if (!this.previousShowState) {
        this.$store.commit('dataLayer/setSelectedRegion', null);
        this.$store.commit('counter/start');
      }

      this.previousShowState = !this.show;
    },
  },
};
</script>

<style lang="scss" scoped>
  // stylelint-disable
  .summary-region {
    background-color: $color-white;
    border-radius: $global-radius;
    left: 50%;
    padding: $global-spacing-unit;
    padding-bottom: $global-spacing-unit-half;
    position: absolute;
    top: 50%;
    transform: translateX(-50%);
    text-align: center;
    min-width: 566px;
    z-index: get-z-index();
    box-shadow: 0 2px 6px rgba($color-silver, .5);

    @include mq($from: mobile) {
      min-width: 260px;
      transform: translate(-50%, -50%);
      width: 260px;
    }

    &__names {
      letter-spacing: 3px;
      font-weight: 900;
    }

    &__city {
      bottom: 4px;
      position: relative;
      word-break: break-word;
    }

    &__place {
      @include font-size(delta-epsilon);
      background-color: $color-cerulean;
      border-radius: $global-radius;
      color: $color-white;
      display: inline-block;
      margin-bottom: 6px;
      padding: 4px;
      position: relative;

      &::before {
        background-color: #657B8F;
        content: '';
        display: block;
        height: 10px;
        left: 50%;
        position: absolute;
        top: 100%;
        transform: translateX(-50%) translateY(2px);
        width: 10px;
      }

      &::after {
        border-bottom: solid 2px transparent;
        border-left: solid 5px #657B8F;
        border-right: solid 5px transparent;
        border-top: solid 2px #657B8F;
        content: '';
        display: block;
        left: 50%;
        position: absolute;
        top: 100%;
        transform: translateX(-50%) translateY(12px);
      }

      @include mq($from: mobile) {
        width: 100%;
      }
    }

    &__subtitle {
      @include font-size(micro, 16px);

      background-color: $color-cerulean;
      bottom: 0;
      display: flex;
      left: 50%;
      flex-direction: row;
      padding-right: 4px;
      position: absolute;
      transform: translateX(-50%);
    }

    &__trophy {
      padding: 0px 4px 0px;
    }

    &__position{
      padding: 0px 0px 0px 4px;
    }

    &__residents {
      padding: 0px 6px 0px 10px;
    }

    &__numbers {
      margin-top: $global-spacing-unit-threequarter;
      text-align: left;

      @include mq($from: mobile) {
        padding-left: 16px;
      }
    }

    &__names {
      border: solid 2px $color-white;
      border-radius: $global-radius-half;
      padding: $global-spacing-unit-quarter 50px;
      text-align: center;

      @include mq($from: mobile) {
        padding-left: 20px;
        padding-right: 20px;
      }
    }

    &__row {
      align-items: center;
      display: flex;
      width: 100%;

      &.\--text {
        padding-bottom: $global-spacing-unit-half;
      }

      @include mq($from: mobile) {
        justify-content: center;
      }
    }

    &__item {
      @include font-size(zeta);

      color: $color-black;
      font-weight: bold;
      padding-left: $global-spacing-unit;
      padding-right: $global-spacing-unit;
      padding-bottom: $global-spacing-unit-quarter;
      width: 20%;

      @include mq($from: mobile) {
        padding-left: 0;
        padding-right: 0;
        width: 50%;
      }
    }

    &__label {
      @include font-size(micro, 12px);

      align-self: flex-end;
      color: $color-lynch;
      letter-spacing: 0px;
      padding-left: $global-spacing-unit;
      padding-right: $global-spacing-unit;
      width: 20%;

      @include mq($from: mobile) {
        padding-left: 0;
        padding-right: 0;
        width: 50%;
      }
    }

    &__disclaimer {
      @include font-size(micro);

      color: #939597;
    }
  }
</style>
